import { notification, Button } from 'antd';
import React from 'react';

/**
 * AI 任务轮询配置常量
 */
export const POLL_CONFIG = {
  MAX_ATTEMPTS: 60,    // 最多轮询60次
  INTERVAL: 3000,      // 3秒间隔
} as const;

/**
 * 显示轮询超时通知，带重试按钮
 * @param key 通知唯一标识（避免重复）
 * @param onRetry 重试回调函数
 */
export const showPollTimeoutNotification = (key: string, onRetry: () => void) => {
  notification.warning({
    key,
    message: 'AI 分析超时',
    description: '任务处理时间较长，可能是服务繁忙。您可以点击重试或稍后刷新页面查看结果。',
    btn: React.createElement(
      Button,
      {
        type: 'primary',
        size: 'small',
        onClick: () => {
          notification.destroy(key);
          onRetry();
        },
      },
      '重试'
    ),
    duration: 0, // 不自动关闭，需要用户操作
  });
};
